import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "crash-item" }
const _hoisted_2 = { class: "item-operation" }
const _hoisted_3 = { class: "tr-left" }
const _hoisted_4 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  class: "operation-icon"
}
const _hoisted_5 = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  class: "operation-icon"
}
const _hoisted_6 = { class: "operation-text" }
const _hoisted_7 = { class: "item-amount" }
const _hoisted_8 = { class: "tr-left" }
const _hoisted_9 = { class: "tr-right center" }
const _hoisted_10 = { class: "amount-text" }
const _hoisted_11 = { class: "item-method" }
const _hoisted_12 = { class: "tr-left" }
const _hoisted_13 = { class: "tr-right center" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "method-text" }
const _hoisted_16 = { class: "item-bonus" }
const _hoisted_17 = { class: "tr-left" }
const _hoisted_18 = {
  key: 0,
  class: "tr-right center"
}
const _hoisted_19 = { class: "item-date" }
const _hoisted_20 = { class: "tr-left" }
const _hoisted_21 = { class: "tr-right center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemIcon = _resolveComponent("ItemIcon")!

  return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
    _createElementVNode("td", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('Profile.operation')), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["tr-right center", [_ctx.type.toLowerCase()]])
      }, [
        (_ctx.type === 'DEPOSIT')
          ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M18 20H6C4.895 20 4 19.105 4 18V6C4 4.895 4.895 4 6 4H18C19.105 4 20 4.895 20 6V18C20 19.105 19.105 20 18 20Z",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, null, -1),
              _createElementVNode("path", {
                d: "M12 8V16",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, null, -1),
              _createElementVNode("path", {
                d: "M16 12H8",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.type === 'WITHDRAW')
          ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M18 20H6C4.895 20 4 19.105 4 18V6C4 4.895 4.895 4 6 4H18C19.105 4 20 4.895 20 6V18C20 19.105 19.105 20 18 20Z",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, null, -1),
              _createElementVNode("path", {
                d: "M16 12H8",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.operation), 1)
      ], 2)
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("td", { class: "item-divider table" }, [
      _createElementVNode("div", { class: "divider" })
    ], -1)),
    _createElementVNode("td", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t('Profile.sum')), 1),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.type === 'WITHDRAW' && _ctx.item)
          ? (_openBlock(), _createBlock(_component_ItemIcon, {
              key: 0,
              icon: _ctx.item.icon,
              class: "item-icon-wrap",
              size: 80
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.amountNormalized), 1)
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("td", { class: "item-divider table" }, [
      _createElementVNode("div", { class: "divider" })
    ], -1)),
    _createElementVNode("td", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t('Profile.method')), 1),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("img", {
          src: _ctx.methodIcon,
          class: "method-icon"
        }, null, 8, _hoisted_14),
        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.methodNormalized), 1)
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("td", { class: "item-divider table" }, [
      _createElementVNode("div", { class: "divider" })
    ], -1)),
    _createElementVNode("td", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.t('Profile.bonus')), 1),
      (_ctx.bonusAmount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.bonusNormalized), 1))
        : _createCommentVNode("", true)
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("td", { class: "item-divider table" }, [
      _createElementVNode("div", { class: "divider" })
    ], -1)),
    _createElementVNode("td", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.t('Profile.date')), 1),
      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.dateNormalized), 1)
    ])
  ]))
}